package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_09_12_Day_4() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes reach the abandoned border. Twelve cold stone huts sit silent. This small village seems to have been abandoned when the Ladikor Dwarves sealed the border.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette leverages a bit of red beard hair to scry a guard. He is resting on a bed in a barracks near the river’s source. He questions the decision to abandon the border outpost based on the threat of giants, but his friend reassures him that the elites have good judgment. They mention that Darnel was supposed to take a key overland.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes scry for shards of the Shield of Concar and find that the shard that was previously in a university town in Yassor has moved to Pentish.")
    }
}
